<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20 no-scrollbar">
    <div class="bg-white rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <div class="my-4">
            <select (change)="onChangeOption($event)"
                class="px-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                @for (item of (grades$ | async); track item.id) {
                <option [selected]="selectedOption == item.id" [value]="item.id">
                    {{item.gradeName}}</option>
                }
                <option [selected]="selectedOption == 'unassigned'" value="unassigned">Unassigned</option>
            </select>
        </div>
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <button (click)="submit()"
                class="bg-primary-500 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button>
        </div>
    </div>
</div>